import { render, staticRenderFns } from "./ViHoliday.vue?vue&type=template&id=49396568"
import script from "./ViHoliday.vue?vue&type=script&lang=js"
export * from "./ViHoliday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports